import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { NewsItem, getNews } from "../data/news";

function pickBannerItem(items: NewsItem[]) {
  const urgent = items.find((item) => item.urgent);
  if (urgent) return urgent;
  return items.find((item) => item.pinned) ?? null;
}

export function HomeNewsBanner() {
  const [items, setItems] = useState<NewsItem[]>([]);

  useEffect(() => {
    getNews({ useFallback: false, limitCount: 10 })
      .then(setItems)
      .catch(() => setItems([]));
  }, []);

  const item = useMemo(() => pickBannerItem(items), [items]);

  if (!item) return null;

  return (
    <section className={item.urgent ? "home-alert home-alert-urgent" : "home-alert"} aria-label={item.urgent ? "Urgent school update" : "Featured school update"}>
      <div className="container home-alert-inner">
        <div>
          <p className="home-alert-label">{item.urgent ? "Urgent Update" : "Pinned Update"}</p>
          <h2>{item.title}</h2>
          {item.summary ? <p>{item.summary}</p> : null}
        </div>
        <Link className="button button-secondary" to={`/news/${item.id}`}>Read More</Link>
      </div>
    </section>
  );
}
